import { Options, Vue } from "vue-class-component"

@Options({
  name: "OpenItemByRouteQuery"
})
export class OpenItemByRouteQuery extends Vue {
  async onOpenItemByRouteQuery() {
    const query = { ...this.$route.query }
    const itemQuery = query?.i as string
    if (!itemQuery || itemQuery === "create") return false
    const lastDashIndex = itemQuery.lastIndexOf("-")
    delete query.i
    await this.$router.replace({ query })
    await this.$router.push({
      name: "Item",
      params: {
        itemAnimation: "true",
        itemId: lastDashIndex === -1 ? itemQuery : itemQuery.slice(lastDashIndex + 1),
        projectId:
          lastDashIndex === -1 ? this.$route.params.projectId : itemQuery.slice(0, lastDashIndex)
      }
    })
    return true
  }
}
